export default "__VITE_ASSET__LuO7pfaN__"